import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { tWithKeyAttr as t } from '../../../i18nHelper';
import styles from './dashboardNavTabs.module.css';

export interface DashboardTab {
  path: string;
  labelKey: string;
  iconClass?: string;
  usesMockData?: boolean;
}

interface DashboardNavTabsProps {
  tabs: DashboardTab[];
}

const DashboardNavTabs: React.FC<DashboardNavTabsProps> = ({ tabs }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActiveTab = (tabPath: string) => {
    return location.pathname.includes(tabPath);
  };

  return (
    <nav className={styles.navTabs}>
      <div className={styles.tabsContainer}>
        {tabs.map((tab) => (
          <button
            key={tab.path}
            className={`${styles.navTab} ${isActiveTab(tab.path) ? styles.active : ''}`}
            onClick={() => navigate(tab.path)}
            type="button"
          >
            {tab.iconClass && <div className={`${styles.tabIcon} ${styles[tab.iconClass]}`} />}
            <span className={styles.tabLabel}>{t(tab.labelKey)}</span>
            {tab.usesMockData && (
              <span className={styles.mockDataBadge} title={t('DASHBOARD_SAMPLE_DATA')}>
                {t('DASHBOARD_MOCK_DATA_BADGE')}
              </span>
            )}
          </button>
        ))}
      </div>
    </nav>
  );
};

export default DashboardNavTabs;
